var heading_default = {
  "fontElementMap": "GQdCv",
  "elementSpacing": "A-ZZ4",
  "headerOne": "_7nnNv A-ZZ4",
  "headerTwo": "Zrdis A-ZZ4",
  "headerThree": "NdhnS A-ZZ4",
  "headerFour": "a5A3t A-ZZ4",
  "headerFive": "_0iVKq A-ZZ4",
  "headerSix": "_1LEAZ A-ZZ4",
  "child": "-EZUV"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
